import React from "react";
import { Typography, Box } from "@mui/material";

const NotFound = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: "#f7f4f2",
      }}
    >
      <Typography variant="h2">404</Typography>
      <Typography variant="h4">Page Not Found</Typography>
    </Box>
  );
};

export default NotFound;
